import { Block, JNode } from '../../types';

export function jNodesToBlocks(jnodes: JNode[]): Block[] {
  return jnodes.map((n) => {
    return {
      id: n.attributes.id,
      content: n.attributes.content!,
      layout: n.attributes.layout!,
    };
  });
}
